import { analyticsClick } from "@/lib/analytics/props";
import { track } from "@/lib/analytics/track";
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@photo-booth/ui/dialog";

export const PrinterButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClick = () => {
    setIsModalOpen(true);
    track('ui_click', {
      element_id: 'how-to-use-button',
    })
  }

  const handleCloseModal = (open: boolean) => {
    setIsModalOpen(open);
    if (!open) {
      track('ui_click', {
        element_id: 'how-to-use-button-open',
      })
    } else {
      track('ui_click', {
        element_id: 'how-to-use-button-close',
      })
    }
  }
  return (
    <>
    <div className="relative inline-block cursor-pointer" {...analyticsClick({ event: "how-to-use-button", feature: "ui" })} onClick={handleClick}>
      <button
        className="
          relative
          inline-flex
          h-8
          w-16
          items-end
          justify-center
          text-vintage-red
          text-sm
          font-family-reenie
          tracking-wide
          bg-natural-white
          border-[1px]
          pb-1
          border-gray-700
          rounded-t-xl
          z-10
          hover:bg-vintage-red
          hover:text-natural-white
          active:bg-vintage-red
          active:text-natural-white
        "
      >
        how to use?
      </button>

      {/* Wide trapezoid base */}
      <div
        className="
          absolute
          -bottom-[24px]
          left-1/2
          -translate-x-1/2
          w-18
          h-12
          bg-vintage-red
          border-l-[1px]
          border-r-[1px]
          rounded-b-lg
        "
        style={{
          clipPath: "polygon(15% 0%, 85% 0%, 100% 100%, 0% 100%)",
        }}
      />
    </div>
    <Dialog open={isModalOpen} onOpenChange={handleCloseModal}>
      <DialogContent className="bg-transparent border-none focus:border-none active:border-none focus-visible:outline-none" showCloseButton={false}>
      <DialogTitle className="text-transparent">How to use?</DialogTitle>
        <img src="/how-to-use.jpg" alt="How to use?" className="w-full h-full" />
      </DialogContent>
    </Dialog>
    </>
  );
};
